import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutComponent } from '../shared/layout/layout.component';
import { Page404Component } from '../shared/page404/page404.component';

const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: 'accountoptions',
        loadChildren: () => import('./caseworker/accountoptions/accountoptions.module').then(m => m.AccountoptionsModule)
      },
      {
        path: 'advent',
        loadChildren: () => import('./caseworker/advent-calendar/advent-calendar.module').then(m => m.AdventCalendarModule)
      },
      {
        path: 'advertisingbox',
        loadChildren: () => import('./caseworker/advertising-box/advertising-box.module').then(m => m.AdvertisingBoxModule)
      },
      {
        path: 'basedatareport',
        loadChildren: () => import('./caseworker/base-data-report/base-data-report.module').then(m => m.BaseDataReportModule)
      },
      {
        path: 'bulk',
        loadChildren: () => import('./caseworker/bulk/bulk.module').then(m => m.BulkModule)
      },
      {
        path: 'businessentity',
        loadChildren: () => import('./caseworker/businessentity/businessentity.module').then(m => m.BusinessentityModule)
      },
      {
        path: 'component',
        loadChildren: () => import('./caseworker/campaign/campaign.module').then(m => m.CampaignModule)
      },
      {
        path: 'card',
        loadChildren: () => import('./caseworker/card/card.module').then(m => m.CardModule)
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./caseworker/dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'event',
        loadChildren: () => import('./caseworker/event/event.module').then(m => m.EventModule)
      },
      {
        path: 'faq',
        loadChildren: () => import('./caseworker/faq/faq.module').then(m => m.FaqModule)
      },
      {
        path: 'interest',
        loadChildren: () => import('./caseworker/interest/interest.module').then(m => m.InterestModule)
      },
      {
        path: 'news',
        loadChildren: () => import('./caseworker/news/news.module').then(m => m.NewsModule)
      },
      {
        path: 'pushmessages',
        loadChildren: () => import('./caseworker/pushmessages/pushmessages.module').then(m => m.PushmessagesModule)
      },
      {
        path: 'release',
        loadChildren: () => import('./caseworker/release/release.module').then(m => m.ReleaseModule)
      },
      {
        path: 'report',
        loadChildren: () => import('./caseworker/report/report.module').then(m => m.ReportModule)
      },
      {
        path: 'reservation',
        loadChildren: () => import('./caseworker/reservation/reservation.module').then(m => m.ReservationModule)
      },
      {
        path: 'rssFeed',
        loadChildren: () => import('./caseworker/rss-feed/rss-feed.module').then(m => m.RssFeedModule)
      },
      {
        path: 'smartquick',
        loadChildren: () => import('./caseworker/smartquick/smartquick.module').then(m => m.SmartquickModule)
      },
      {
        path: 'task',
        loadChildren: () => import('./caseworker/tasks/tasks.module').then(m => m.TasksModule)
      },
      {
        path: 'ticket',
        loadChildren: () => import('./caseworker/ticket/ticket.module').then(m => m.TicketModule)
      },
      {
        path: 'userreport',
        loadChildren: () => import('./caseworker/user-report/user-report.module').then(m => m.UserReportModule)
      },
      {
        path: 'appointment',
        loadChildren: () => import('./caseworker/appointment/appointment.module').then(m => m.AppointmentModule)
      },
      {
        path: 'clubstate',
        loadChildren: () => import('./caseworker/clubstate/clubstate.module').then(m => m.ClubstateModule)
      },
      {
        path: 'partnerreport',
        loadChildren: () => import('./caseworker/partnerreport/partnerreport.module').then(m => m.PartnerreportModule)
      },
      {
        path: 'partnerreport',
        loadChildren: () => import('./caseworker/partnerreport/partnerreport.module').then(m => m.PartnerreportModule)
      }, 
      {
        path: 'household',
        loadChildren: () => import('./caseworker/household/household.module').then(m => m.HouseholdModule)
      },      
      {
        path: 'position',
        loadChildren: () => import('./caseworker/position/position.module').then(m => m.PositionModule)
      },
      {
        path: 'legal',
        loadChildren: () => import('../shared/legal/legal.module').then( m => m.LegalModule)
      },
      {
        path: '',
        redirectTo: 'task',
        pathMatch: 'full',
      },
      { path: '404', component: Page404Component },
      { path: '**', redirectTo: '/404', pathMatch: 'full' }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CaseworkerRoutingModule {

}